const e = {
  name: "Inheritence",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0002 1.58594L17.4144 7.00015L16.0002 8.41436L13.0002 5.41436V14.4143L5.00015 22.4143L3.58594 21.0001L11.0002 13.5859V5.41436L8.00015 8.41436L6.58594 7.00015L12.0002 1.58594Z" fill="currentColor"/>
<path d="M20.4144 21.0002L15.0002 15.5859L13.5859 17.0002L19.0002 22.4144L20.4144 21.0002Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as Inheritence
};
